import MetabaseAnalyticsCard from "components/Templates/MetabaseAnalyticsCard"
import React from "react"

const AlternateSalesAnalyticsPage = () => {
  return (
    <div className="p-3">
      <MetabaseAnalyticsCard filter={{ dashboard: 21 }} />
    </div>
  )
}

export default AlternateSalesAnalyticsPage
